var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"banner",style:({ backgroundImage: 'url(' + _vm.backgroundImage + ')' })},[_c('div',{staticClass:"banner-title-one"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"banner-title-two"},[_vm._v(_vm._s(_vm.description))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }